import React from 'react'

import Image from 'next/image'

import { cx } from '@linaria/core'

import { ChevronLeftIcon } from '../icons'
import { Container } from './Container'

export const LpHeader: React.FC<{ hideBrowserBackButton?: boolean }> = (
  props
) => {
  return (
    <Container>
      <div className="h-[50px] relative flex justify-between mx-4 md:mx-0">
        <div className="w-5 flex items-center">
          <button
            onClick={() => history.back()}
            className={cx(props.hideBrowserBackButton && 'hidden')}
          >
            <ChevronLeftIcon className="fill-text" />
          </button>
        </div>
        <Image
          width={130}
          height={24.87}
          src="/images/logo-mb.svg"
          className="m-auto"
          alt="Foodies Prime"
        />
        <div className="w-5 h-[1px]" />
      </div>
    </Container>
  )
}
